module.exports = __webpack_public_path__ + "img/banner-12.c8b0796e.jpg";